import type { EmailSnippet, EmailSnippetInput } from "@/schema/email-snippet"

import { ApiContext, apiContextFetch } from "@/hooks/api/base"

export function fetchEmailSnippets(context: ApiContext, options?: { scope?: "company" | "book" }) {
  return apiContextFetch<{ email_snippets: EmailSnippet[] }>(
    context,
    `email_snippets${options?.scope ? `?scope=${options.scope}` : ""}`
  )
}

export function createEmailSnippet(
  context: ApiContext,
  emailSnippet: EmailSnippetInput,
  options?: { scope?: "company" | "book" }
) {
  return apiContextFetch<{ email_snippet: EmailSnippet }>(
    context,
    `email_snippets${options?.scope ? `?scope=${options.scope}` : ""}`,
    {
      method: "POST",
      body: JSON.stringify({ email_snippet: emailSnippet }),
    }
  )
}

export function updateEmailSnippet(context: ApiContext, id: string, emailSnippet: Partial<EmailSnippetInput>) {
  return apiContextFetch<{ email_snippet: EmailSnippet }>(context, `email_snippets/${id}`, {
    method: "PATCH",
    body: JSON.stringify({ email_snippet: emailSnippet }),
  })
}

export function destroyEmailSnippet(context: ApiContext, id: string) {
  return apiContextFetch<void>(context, `email_snippets/${id}`, { method: "DELETE" })
}
